import { kernelStorageClient } from "../../../../../api/services";
import { EditorSettings } from "../../../../types/EditorSettings";
import {
  ActionKey,
  EditorSettingsAction,
} from "../../../actions/editorSettings";
import {
  ActionKey as SessionActionKey,
  SessionAction,
} from "../../../actions/session";
import { createEditorSettings } from "../../../utils/createEditorSettings";

const defaultState: EditorSettings = createEditorSettings(
  kernelStorageClient.readEditorSettings()
);

/** The editor settings redux state (persisted to local storage). */
export const settings = (
  state: EditorSettings = defaultState,
  action: SessionAction | EditorSettingsAction
): EditorSettings => {
  switch (action.type) {
    case SessionActionKey.SET_SESSION_STATE:
      return action.payload.session.settings;
    case ActionKey.SET_DEVICE_SETTINGS:
      return action.payload.settings;
    default:
      return state;
  }
};
